import * as React from "react";
import { styled } from "@mui/material";
import { useEffect } from "react";
import { signOut } from "user-management/src/cognito/kahunUserAuth";

//region [[ Styles ]]

const LogoutView = styled("div")({});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface LogoutProps {
  children: React.ReactNode;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

/**************************************************
 * A small wrapper component to render a logout ***
 **************************************************/

export const Logout = ({ ...props }: LogoutProps) => {
  useEffect(() => {
    signOut();
  }, []);

  return <LogoutView>{props.children}</LogoutView>;
};
